const settingsReducer = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_SETTINGS_COMPLETE':
      return Object.assign({}, state, {
        ...action.settings,
      });
    default:
      return state;
  }
};

export default settingsReducer;
